import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { axCoerceString } from '@awayfl/avm2';
import { somewhatImplemented, release, notImplemented } from '@awayfl/swf-loader';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: NetConnection
var NetConnection = /** @class */ (function (_super) {
    __extends(NetConnection, _super);
    function NetConnection() {
        var _this = _super.call(this) || this;
        _this._connected = false;
        _this._proxyType = 'none';
        _this._objectEncoding = NetConnection.defaultObjectEncoding;
        _this._usingTLS = false;
        return _this;
        //Telemetry.instance.reportTelemetry({topic: 'feature', feature: Telemetry.Feature.NETCONNECTION_FEATURE});
    }
    // JS -> AS Bindings
    NetConnection.prototype.close = function () {
        this.invoke(1);
    };
    NetConnection.prototype.addHeader = function (operation, mustUnderstand, param) {
        if (mustUnderstand === void 0) { mustUnderstand = false; }
        if (param === void 0) { param = null; }
        this._invoke(3, [axCoerceString(operation), !!mustUnderstand, param]);
    };
    NetConnection.prototype.call = function (command, responder /* more args can be provided */) {
        arguments[0] = axCoerceString(command);
        this._invoke(2, arguments);
    };
    Object.defineProperty(NetConnection, "defaultObjectEncoding", {
        get: function () {
            return NetConnection._defaultObjectEncoding;
        },
        set: function (version /*uint*/) {
            version = version >>> 0;
            NetConnection._defaultObjectEncoding = version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "connected", {
        get: function () {
            return this._connected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "uri", {
        get: function () {
            return this._uri;
        },
        enumerable: false,
        configurable: true
    });
    NetConnection.prototype.connect = function (command) {
        /*
    command = axCoerceString(command);

    release || somewhatImplemented("public flash.net.NetConnection::connect");
    this._uri = command;
    if (!command) {
      this._connected = true;
      this.dispatchEvent(new NetStatusEvent(NetStatusEvent.NET_STATUS, false, false,
        this.sec.createObjectFromJS({ level : 'status', code : 'NetConnection.Connect.Success'})));
    } else {
      var parsedURL = RtmpJs.parseConnectionString(command);
      if (!parsedURL || !parsedURL.host ||
          (parsedURL.protocol !== 'rtmp' && parsedURL.protocol !== 'rtmpt' && parsedURL.protocol !== 'rtmps')) {
        this.dispatchEvent(new NetStatusEvent(NetStatusEvent.NET_STATUS, false, false,
          this.sec.createObjectFromJS({ level : 'status', code : 'NetConnection.Connect.Failed'})));
        return;
      }

      var service: IRootElementService = this.sec.player;

      var rtmpProps = this.sec.createObjectFromJS({
        app: parsedURL.app,
        flashver: Capabilities.version,
        swfUrl: service.swfUrl,
        tcUrl: command,
        fpad: false,
        audioCodecs: 0x0FFF,
        videoCodecs: 0x00FF,
        videoFunction: 1,
        pageUrl: service.pageUrl || service.swfUrl,
        objectEncoding: 0
      });

      this._protocol = parsedURL.protocol;

      var secured = parsedURL.protocol === 'rtmps' ||
                    (parsedURL.protocol === 'rtmpt' && (parsedURL.port === 443 || parsedURL.port === 8443));
      this._usingTLS = secured;
      var rtmpConnection: RtmpJs.BaseTransport = parsedURL.protocol === 'rtmp' || parsedURL.protocol === 'rtmps' ?
        new RtmpJs.Browser.RtmpTransport({ host: parsedURL.host, port: parsedURL.port || 1935, ssl: secured }) :
        new RtmpJs.Browser.RtmptTransport({ host: parsedURL.host, port: parsedURL.port || 80, ssl: secured });
      this._rtmpConnection = rtmpConnection;
      this._rtmpCreateStreamCallbacks = [null, null]; // reserve first two

      rtmpConnection.onresponse = function (e) {
        //
      };
      rtmpConnection.onevent = function (e) {
        //
      };
      rtmpConnection.onconnected = function (e) {
        this._connected = true;
        this.dispatchEvent(new this.sec.flash.events.NetStatusEvent(events.NetStatusEvent.NET_STATUS,
          false, false,
          this.sec.createObjectFromJS({ level : 'status', code : 'NetConnection.Connect.Success'})));
      }.bind(this);
      rtmpConnection.onstreamcreated = function (e) {
        console.log('#streamcreated: ' + e.streamId);
        var callback = this._rtmpCreateStreamCallbacks[e.transactionId];
        delete this._rtmpCreateStreamCallbacks[e.transactionId];
        callback(e.stream, e.streamId);
      }.bind(this);
      rtmpConnection.connect(rtmpProps);
    }*/
    };
    NetConnection.prototype._createRtmpStream = function (callback) {
        var transactionId = this._rtmpCreateStreamCallbacks.length;
        this._rtmpCreateStreamCallbacks[transactionId] = callback;
        this._rtmpConnection.createStream(transactionId, null);
    };
    Object.defineProperty(NetConnection.prototype, "client", {
        get: function () {
            return this._client;
        },
        set: function (object) {
            this._client = object;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "objectEncoding", {
        get: function () {
            return this._objectEncoding;
        },
        set: function (version /*uint*/) {
            version = version >>> 0;
            release || somewhatImplemented('public flash.net.NetConnection::set objectEncoding');
            this._objectEncoding = version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "proxyType", {
        get: function () {
            return this._proxyType;
        },
        set: function (ptype) {
            ptype = axCoerceString(ptype);
            release || somewhatImplemented('public flash.net.NetConnection::set proxyType');
            this._proxyType = ptype;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "connectedProxyType", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get connectedProxyType');
            return this._connectedProxyType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "usingTLS", {
        get: function () {
            return this._usingTLS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "protocol", {
        get: function () {
            return this._protocol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "maxPeerConnections", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get maxPeerConnections');
            return this._maxPeerConnections;
        },
        set: function (maxPeers /*uint*/) {
            maxPeers = maxPeers >>> 0;
            release || notImplemented('public flash.net.NetConnection::set maxPeerConnections');
            this._maxPeerConnections = maxPeers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "nearID", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get nearID');
            return this._nearID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "farID", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get farID');
            return this._farID;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "nearNonce", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get nearNonce');
            return this._nearNonce;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "farNonce", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get farNonce');
            return this._farNonce;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NetConnection.prototype, "unconnectedPeerStreams", {
        get: function () {
            release || notImplemented('public flash.net.NetConnection::get unconnectedPeerStreams');
            return this._unconnectedPeerStreams;
        },
        enumerable: false,
        configurable: true
    });
    NetConnection.prototype.invoke = function (index /*uint*/) {
        index = index >>> 0;
        return this._invoke(index, Array.prototype.slice.call(arguments, 1));
    };
    NetConnection.prototype._invoke = function (index, args) {
        var simulated = false;
        var result;
        switch (index) {
            case 1: // close
            case 2: // call, e.g. with ('createStream', <Responder>)
                simulated = true;
                break;
        }
        (simulated ? somewhatImplemented : notImplemented)('private flash.net.NetConnection::_invoke (' + index + ')');
        return result;
    };
    // Called whenever the class is initialized.
    NetConnection.classInitializer = null;
    // AS -> JS Bindings
    NetConnection._defaultObjectEncoding = 3 /* AMF3 */;
    return NetConnection;
}(EventDispatcher));
export { NetConnection };
